import { RolesActionTypes } from "./roles-types";

const INITIAL_STATE = {
  allRoles: null,
  searchRolesQuery: {
    PageSize: 10,
    PageNumber: 1,
    SortDesc: false,
    SortBy: "name",
    Filters: [],
  },
  isFetchingRoles: false,
  isFetchingAllRoles: false,
  isFetchingRolesOnPage: false,
  roles: null,
  rolesOnPage: null,
  numRoles: 0,
  selectedRoles: [],
};

const rolesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RolesActionTypes.FETCH_ROLES_START:
      return {
        ...state,
        isFetchingRoles: true,
      };

    case RolesActionTypes.FETCH_ROLES_SUCCESS:
      return {
        ...state,
        isFetchingRoles: false,
        roles: action.payload[0],
        numRoles: action.payload[1],
      };

    case RolesActionTypes.FETCH_ROLES_FAILURE:
      return {
        ...state,
        isFetchingRoles: false,
        errorMessage: action.payload,
      };
    case RolesActionTypes.SET_ROLES_ON_PAGE: //setting the roles that are displayed on the page
      return {
        ...state,
        rolesOnPage: action.payload,
      };

    case RolesActionTypes.SET_SEARCH_ROLES_QUERY:
      return {
        ...state,
        searchRolesQuery: action.payload,
      };

    case RolesActionTypes.ADD_SELECTED_ROLE:
      return {
        ...state,
        selectedRoles: [...state.selectedRoles, action.payload],
      };

    case RolesActionTypes.DELETE_SELECTED_ROLE:
      return {
        ...state,
        selectedRoles: [
          ...state.selectedRoles.slice(
            0,
            state.selectedRoles.indexOf(action.payload)
          ),
          ...state.selectedRoles.slice(
            state.selectedRoles.indexOf(action.payload) + 1
          ),
        ],
      };
    case RolesActionTypes.SET_SELECTED_ROLE:
      return {
        ...state,
        selectedRoles: action.payload,
      };

    default:
      return state;
  }
};

export default rolesReducer;
